export const GTM_ERROR_CODES = Object.keys(ERROR_CODES)
    .map((key) => ({
        [key]: ERROR_CODES[key].replace(/_/g, '-'),
    }))
    .reduce((result, obj) => ({ ...result, ...obj }), {});
